import { getAuthenticationHeaders } from "common/apis/APIUtility";
import elcos from "common/apis/ElcosAPI";
import MqttService from "../mqtt/MqttService";

const DevicesService = {
  listGateways: async () => {
    const config = await getAuthenticationHeaders();
    return await elcos.get("/gateways", config);
  },
  listUserGateways: async (user) => {
    const config = await getAuthenticationHeaders();
    
    return await elcos.get(`/gateways/users/${user}`, config);
  },
  associateUserToGateway: async (gatewayId, provisioningCode, licenceId="", username, email) => {
    const config = await getAuthenticationHeaders();
    const body = { associations: [{gatewayId, provisioningCode, licenceId: licenceId, username, email}] };
    
    return await elcos.post("/associations", body, config); 
  },
  removeUserGWAssociation: async (username, gatewayId) => {
    const config = await getAuthenticationHeaders();
    const body = { associations: [{ username, gatewayId }]};
    config.data = body;
    return await elcos.delete(`/associations`, config);
  },
  getUserGWAssociations: async (username, active) => {
    const config = await getAuthenticationHeaders();
    const activeString = active ? "?active=true" : "";
    return await elcos.get(`/associations/${username}${activeString}`, config);
  },
  addGateway: async (id, provisioningCode) => {
    const config = await getAuthenticationHeaders();
    const body = {id, provisioningCode};
    return await elcos.post("/gateways", body, config);
  },
  getGateway: async (id) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/gateways/${id}`, config); 
  },
  deleteGateway: async (id) => {
    const config = await getAuthenticationHeaders();
    return await elcos.delete(`/gateways/${id}`, config);
  },
  executeDeviceCommand: async (cmd, gatewayId, deviceId, username, userLevel) => {
    const metrics = [
      {
        "name":"code",
        "type": 3,
        "value": Number.parseInt(cmd.code.val)
      },
      {
        "name":"param",
        "type": 3,
        "value": cmd.param?.val ? Number.parseInt(cmd.param.val): 0
      }
    ]
    const options = { type: "EXE", gatewayId, resource: `${deviceId}/custom`, metrics }
    if (userLevel === 1) {
      options.manufacturer = username;
    }
    await MqttService.cmdRequest(options);
  },
  listDeviceLogs: async (gatewayId, deviceId) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/logs/${gatewayId}/${deviceId}`, config);
  },
  downloadDeviceLog: async (gatewayId, deviceId, fileId, mobile = false) => {
    const config = await getAuthenticationHeaders();
    const response = await elcos.get(`/logs/${gatewayId}/${deviceId}/${fileId}`, config);

    const timestamp = fileId.split("_")[1];
    const dt = new Date(Number.parseInt(timestamp));

    const pad2 = (n) => n < 10 ? '0' + n : n.toString();

    const dateString = `${dt.getFullYear().toString().substring(2)}${pad2(dt.getMonth()+1)}${pad2(dt.getDate())}_${pad2(dt.getHours())}${pad2(dt.getMinutes())}`;
    const filename = `log_${deviceId}_${dateString}.txt`;

    if (mobile) {
      return response.data;
    } else {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', filename);
      document.body.appendChild(link);
      link.click();
    }
    
  },
  listTelemetries: async (deviceId) => {
    const config = await getAuthenticationHeaders();
    return await elcos.get(`/telemetries/${deviceId}`, config);
  },
  removeTelemetry: async (deviceId, createdOn) => {
    const config = await getAuthenticationHeaders();
    const body = {createdOn};
    return await elcos.post(`/telemetries/${deviceId}/${createdOn}/remove`, body, config);
  },
  downloadTelemetry: async (deviceId, fileName, description) => {
    const config = await getAuthenticationHeaders();

    try {
        const response = await elcos.get(`/telemetries/${deviceId}?fileName=${fileName}`, config);

        // Assumi che la risposta sia in formato CSV
        const csvData = response.data;

        // Crea un Blob per il file CSV
        const blob = new Blob([csvData], { type: 'text/csv' });
        const url = URL.createObjectURL(blob);

        // Crea un link per il download
        const a = document.createElement('a');
        a.href = url;
        a.download = description + '.csv'; // Imposta il nome del file con estensione CSV
        document.body.appendChild(a);
        a.click();

        // Pulisci
        URL.revokeObjectURL(url);
        document.body.removeChild(a);
    } catch (error) {
        console.error('Error downloading telemetry:', error);
        throw error;
    }
  },
  generateTelemetries: async (deviceId, startTs, endTs, description) => {
    
    if(startTs > endTs) {
      const temp = startTs;
      startTs = endTs;
      endTs = temp;
    }

    const config = await getAuthenticationHeaders();
    try {
      const body = {startTs, endTs, description};
      await elcos.post(`/telemetries/${deviceId}`, body, config);
      return true;
    } catch (error) {
      console.log(error);
      if (error?.response?.status !== 404) {
        throw error;
      } else if (error?.response?.status === 404) {
        return false;
      }
    }
  }
};

export default DevicesService;
